import { Component, Prop, h, Element } from '@stencil/core';

/**
 * @slot heading - {required}, <me-heading variant="2">
 * @slot subheading - {required}, <me-text>
 */
@Component({
  tag: 'related-links-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class RelatedLinksType1 {
  @Element() el!: HTMLElement;

  /**
   * @type {array}
   * @links.type {object}
   * @links.property {string} label - Link text
   * @links.property {string} href - Link
   * @links.required label
   * @links.required href
   * @minItems 1
   */
  @Prop() links!: any[];

  private parsedLinks: any[] = [];

  componentWillLoad() {
    if (Array.isArray(this.links)) {
      this.parsedLinks = this.links;
    } else if (typeof this.links === 'string') {
      // Try to parse links if it's a JSON string (from SSR or HTML attribute)
      try {
        this.parsedLinks = JSON.parse((this.links as string).replace(/&quot;/g, '"'));
      } catch {
        this.parsedLinks = [];
      }
    } else {
      // Fallback: try data-links attribute
      const dataLinks = this.el.getAttribute('data-links') || this.el.getAttribute('links');
      if (dataLinks) {
        try {
          this.parsedLinks = JSON.parse(dataLinks.replace(/&quot;/g, '"'));
        } catch {
          this.parsedLinks = [];
        }
      } else {
        this.parsedLinks = [];
      }
    }
    if (!this.parsedLinks || this.parsedLinks.length === 0) {
      throw new Error('Required prop links is missing');
    }
  }

  render() {
    const links = this.parsedLinks || [];
    return (
      <me-section yGap="2xl" yGapLg="5xl" role="region" aria-label="Related Links">
        <header class="related-links-type-1__header">
          <slot name="heading"></slot>
          <slot name="subheading"></slot>
        </header>
        <div class="related-links-type-1__tags-list" itemScope itemType="https://schema.org/ItemList">
          {links.map((link, index) => (
            <a href={link.href} class="related-links-type-1__tags-list-item" itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
              <me-icon name="arrows--chevron-right" class="related-links-type-1__link-icon"></me-icon>
              <span class="related-links-type-1__link-text" itemProp="name">
                {link.label}
              </span>
              <meta itemProp="position" content={String(index + 1)} />
            </a>
          ))}
        </div>
      </me-section>
    );
  }
}
